export default __webpack_public_path__ + "static/media/ModalImage8.545af989.PNG";